import { Keypoint } from '../types'

/**
 * Normalize keypoints array length to match the expected schema length
 * @param keypoints Current keypoints array
 * @param targetLength Expected length based on schema
 * @returns Normalized keypoints array
 */
export function normalizeKeypointsLength(keypoints: Keypoint[], targetLength: number): Keypoint[] {
  if (targetLength <= 0) {
    console.warn('Invalid target length for keypoints normalization:', targetLength)
    return keypoints
  }

  if (keypoints.length === targetLength) {
    return keypoints
  }

  if (keypoints.length > targetLength) {
    console.warn(
      `Keypoints array length (${keypoints.length}) exceeds schema length (${targetLength}). Truncating extra keypoints.`
    )
    return keypoints.slice(0, targetLength)
  }

  // Pad with not_labeled keypoints
  const normalized = [...keypoints]
  const toAdd = targetLength - keypoints.length

  for (let i = 0; i < toAdd; i++) {
    normalized.push({
      x: -1,
      y: -1,
      confidence: 1.0,
      visibility: 'not_labeled',
    })
  }

  return normalized
}

/**
 * Check if a keypoint is set (has valid coordinates)
 */
export function isKeypointSet(keypoint: Keypoint | undefined): boolean {
  return keypoint !== undefined && keypoint.x >= 0 && keypoint.y >= 0
}

/**
 * Check if a keypoint is unset (has invalid coordinates or is undefined)
 */
export function isKeypointUnset(keypoint: Keypoint | undefined): boolean {
  return !isKeypointSet(keypoint)
}
